import * as React from 'react'

const RefreshIcon = (props) => (
  <svg
    width={props.width}
    height={props.icon}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.072 10.96v3.333-3.333Z" fill={props.fill} />
    <path
      d="M14.665 8A6.67 6.67 0 0 1 8 14.667c-3.68 0-5.927-3.707-5.927-3.707m0 0h3.013m-3.013 0v3.333M1.332 8c0-3.68 2.96-6.667 6.667-6.667 4.446 0 6.666 3.707 6.666 3.707m0 0V1.707m0 3.333h-2.96"
      stroke={props.fill}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

RefreshIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: '#3B82F6'
}

export { RefreshIcon }
